'use strict';

var fraudnetInitDone = false;
module.exports = {
	init: function init(options) {

		if (fraudnetInitDone || !options ||
			!options.sessionId || !options.sourceId || !options.url
		) {
			return;
		}
		fraudnetInitDone = true;

		const body = document.getElementsByTagName("body")[0];

		const fnGlobalVarsScript = document.createElement("script");
		fnGlobalVarsScript.type = "application/json";
		fnGlobalVarsScript.setAttribute("fncls", "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99");
		fnGlobalVarsScript.text = '{"f": "' + options.sessionId + '","s": "' + options.sourceId + '"}';
		body.appendChild(fnGlobalVarsScript);

		(function() {
			var dom, doc, where, iframe = document.createElement('iframe');
			iframe.src = "javascript:false";
			iframe.title = "";
			iframe.role = "presentation";
			(iframe.frameElement || iframe).style.cssText = "display:none; width: 0; height: 0; border: 0";

			where = document.getElementsByTagName('script');
			where = where[where.length - 1];
			where.parentNode.insertBefore(iframe, where);
			try {
				doc = iframe.contentWindow.document;
			} catch (e) {
				dom = document.domain;
				iframe.src = "javascript:var d=document.open();d.domain='" + dom + "';void(0);";
				doc = iframe.contentWindow.document;
			}
			doc.open()._l = function () {
				var js = this.createElement("script");
				if (dom) {
					this.domain = dom;
				}
				js.id = "js-iframe-async";
				js.src = options.url;
				this.body.appendChild(js);
			};
			doc.write('<body onload="document._l();">');
			doc.close();
		})();
		return;
	}
};


/** WEBPACK FOOTER **
 ** ./src/lib/fraudnet.js
 **/